var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.586 39.625v-.247a21.541 21.541 0 01-6.942 7.304 21.51 21.51 0 01-9.5 3.344l-.322.033C47.337 51.385 43.353 41.527 47.1 36.702c3.048-3.926 7.502-2.629 9.021-.918a.128.128 0 00.219-.114c-.409-1.758-2.275-7.04-10.004-7.04-10.412 0-17.092 10.197-16.233 21.39a23.033 23.033 0 01-2.663-10.652c0-5.431 1.718-9.99 5.156-13.675 3.437-3.685 7.829-5.53 13.175-5.533 5.26 0 9.611 1.844 13.052 5.533l.038.043a16.022 16.022 0 014.116 8.746c.475 3.427.356 8.11-2.944 10.828a.1.1 0 00.086.176 25.785 25.785 0 003.352-1.15c4.107-1.707 10.573-5.31 13.132-12.654a.91.91 0 00.024-.527 30.429 30.429 0 00-8.185-14.217c-6.115-6.114-13.664-9.173-22.647-9.18-8.983-.006-16.537 3.06-22.662 9.198-6.115 6.123-9.17 13.6-9.168 22.432V40.324c.537 26.795 31.81 40.366 31.81 40.366s31.26-13.571 31.811-40.366v-.338-.36z",
    fill: "url(#spiner_icon_svg__paint0_linear_2219_322)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "spiner_icon_svg__paint0_linear_2219_322",
    x1: 45.825,
    y1: 80.488,
    x2: 83.853,
    y2: 27.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03D9B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1CBBD9"
  })))));
}
export default SvgSpinerIcon;